import { SystemCodeIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/system-manager',
    component: () => import('@/layouts/index.vue'),
    redirect: '/system-manager/agent-list',
    name: 'systemManager',
    meta: {
      title: '系统配置',
      icon: shallowRef(SystemCodeIcon),
      orderNo: 0,
      permission: ['AgentList', 'SalesOrderTagList', 'DeductionTypeList', 'ProductSourceList', 'AccessoryList'],
    },
    children: [
      {
        path: 'agent-list',
        name: 'agentList',
        component: () => import('@/pages/system-management/agent-list.vue'),
        meta: {
          title: '代理商管理',
          permission: ['AgentList'],
        },
      },
      {
        path: 'product-source-list',
        name: 'productSourceList',
        component: () => import('@/pages/system-management/product-source-list.vue'),
        meta: {
          title: '产品来源管理',
          permission: ['ProductSourceList'],
        },
      },
      // {
      //   path: 'agent-account-manager',
      //   name: 'agentAccountManager',
      //   component: () => import('@/pages/system-management/agent-account-manager.vue'),
      //   meta: {
      //     title: '代理商账号管理',
      //     permission: ['AgentAccountManager']
      //   },
      // },
      {
        path: 'agent-add',
        name: 'agentAdd',
        component: () => import('@/pages/system-management/agent-add.vue'),
        meta: {
          title: '新增代理商',
          hidden: true,
          permission: ['AgentCreate', 'AgentEdit'],
          parentRouteName: 'agentList',
        },
      },
      {
        path: 'tag-list',
        name: 'tagList',
        component: () => import('@/pages/system-management/tag-list.vue'),
        meta: {
          title: '标签管理',
          permission: ['SalesOrderTagList'],
        },
      },
      {
        path: 'deduction-type-manager',
        name: 'deductionTypeManager',
        component: () => import('@/pages/system-management/deduction-type-manager.vue'),
        meta: {
          title: '扣款类型管理',
          permission: ['DeductionTypeList'],
        },
      },
      {
        path: 'fitting-manager',
        name: 'fittingManager',
        component: () => import('@/pages/system-management/fitting-manager.vue'),
        meta: {
          title: '配件管理',
          permission: ['AccessoryList'],
        },
      },
    ],
  },
] as RouteRecordRaw[];
